import { render, staticRenderFns } from "./SchoolListAddNew.vue?vue&type=template&id=5374de52&"
import script from "./SchoolListAddNew.vue?vue&type=script&lang=js&"
export * from "./SchoolListAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports